import { loadSettings } from '../store/SettingsContext';

export default class AttendanceService {
  constructor(studentService = null) {
    this.studentService = studentService;
  }

  resolveThreshold(threshold) {
    if (typeof threshold === 'number') return threshold;
    const settings = loadSettings();
    return Number(settings.attendanceThreshold || 70);
  }

  isBelowThreshold(student, threshold) {
    return (student.attendance?.rate || 0) < this.resolveThreshold(threshold);
  }

  getAverageAttendance(students) {
    if (!students.length) return 0;
    const total = students.reduce((sum, s) => sum + (s.attendance?.rate || 0), 0);
    return Math.round(total / students.length);
  }

  getAttendanceTrend(student) {
    const weeks = student.attendance.last8Weeks || [];
    if (weeks.length < 2) return 'stable';
    const change = weeks[weeks.length - 1] - weeks[0];
    if (change > 5) return 'improving';
    if (change < -5) return 'declining';
    return 'stable';
  }

  shouldAutoFlag(student, threshold) {
    return (student.attendance?.rate || 0) < this.resolveThreshold(threshold);
  }

  buildAttendanceTimeline(student) {
    const reasons = student.attendance.absenceReasons || [];
    const logs = student.attendance.logs || [];
    const severityForStatus = (status) => {
      if (status === 'unauthorised absence') return 'high';
      if (status === 'session stopped') return 'high';
      if (status === 'disrupted') return 'medium';
      if (status === 'partially attended') return 'medium';
      if (status === 'late') return 'medium';
      if (status === 'authorised absence') return 'medium';
      return 'low';
    };
    const threshold = this.resolveThreshold();
    const reasonEvents = reasons.map((r, idx) => ({
      id: `att-${student.id}-${idx}`,
      category: 'Attendance',
      date: r.date,
      description: `Absence: ${r.reason || 'Recorded'}`,
      severity: student.attendance.rate < threshold ? 'high' : 'medium'
    }));
    const logEvents = logs.map((log, idx) => ({
      id: `attlog-${student.id}-${idx}`,
      category: 'Attendance',
      date: log.date,
      description: `Session: ${log.status}${log.programme ? ` (${log.programme})` : ''}${log.notes ? ` - ${log.notes}` : ''}`,
      severity: severityForStatus(log.status)
    }));
    return [...logEvents, ...reasonEvents];
  }
}
